import React, { useState } from "react";
import moment from "moment";
import * as FeatherIcon from "react-feather";
import { X } from "react-feather";
import { floatToCurrency } from "../../constants/validate";

import "./index.scss";
import _ from "lodash";

export default function Table({
  title,
  headers,
  objectKeys,
  items,
  whiteSpace = "normal",
  tableIcons,
  hasScroll = false,
  collapseColumns = true,
}) {
  const loggedUser = JSON.parse(localStorage.getItem("user"))


  const debts = formatDebts(items);
  const [open, setOpen] = useState(true);
  function formatDebts(items) {
    items.sort((a, b) => new Date(a.due_date) - new Date(b.due_date));

    const formattedDebts = items.map((debtItem) => {
      const formattedDebtItem = { ...debtItem };

      Object.keys(formattedDebtItem).forEach((key) => {
        if (key.includes("date")) {
          formattedDebtItem[key] = moment(formattedDebtItem[key]).format(
            "DD/MM/YYYY"
          );
        }

        if (key.includes("value")) {
          formattedDebtItem[key] = floatToCurrency(
            Number(formattedDebtItem[key])
          );
        }
      });

      return formattedDebtItem;
    });

    return formattedDebts;
  }

  const CustomIcon = ({ icon, sizeIcon }) => {
    const Icon = FeatherIcon[icon];
    return <Icon size={sizeIcon} />;
  };

  function returnClassName() {
    let className = "table";

    if (hasScroll) className += " table--scroll";
    if (collapseColumns) className += " table--collapse-columns";

    return className;
  }

  return (
    <div className={returnClassName()}>
      {title && <p>Natureza do débito</p>}
      {loggedUser['roles_id'] === 3 ?
        <div
          className={
            open
              ? "table__disclaimer"
              : "table__disclaimer table__disclaimer--closed"
          }
        >
          {/* <X size={20} onClick={() => setOpen(false)} /> */}
          Os títulos abaixo listados são os habilitados para negociação nesta
          plataforma, que podem ou não representar a totalidade das obrigações
          junto à Vibra. Busque sempre se certificar, por meio de controles
          próprios ou consultas à Vibra, se há obrigações aqui não relacionadas,
          pois, em havendo, estas terão que ser quitadas/negociadas à parte. Não
          há, portanto, automática quitação para todas as pendências. Serão dadas
          como quitadas apenas as relacionadas no instrumento contratual que aqui
          será disponibilizado, isto, claro, se os pagamentos ocorrerem na forma
          lá prevista.
        </div>
        : ""
      }

      <table>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header} style={{ whiteSpace }}>
                <div>
                  {!_.isEmpty(tableIcons) && tableIcons[header] && (
                    <CustomIcon icon={tableIcons[header]} sizeIcon={16} />
                  )}
                  <span>{header}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {debts.map((debt, index) => (
            <tr key={`${debt.reference}-${index}`}>
              {objectKeys.map((objectKey, indexCell) => {
                if (objectKey === "id") return null;

                return (
                  <td key={indexCell} data-label={headers[indexCell]}>
                    <span title={debt[objectKey]}>{debt[objectKey]}</span>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
